<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<operaciones-reembolso-actualizar #appoperacionesreembolso (TerminoGuardarRegistro)="TerminoGuardarOperacionesReembolso()"></operaciones-reembolso-actualizar>

<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <h2>Seleccione <br/> para filtrar</h2>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Cliente (*)</mat-label>
                    <mat-select formControlName="idAliado" (ngModelChange)="Cambio_Aliado()">
                        <mat-option [value]="item.id" *ngFor="let item of this.listasAliados">{{item.descripcion}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Programa (*)</mat-label>
                    <mat-select formControlName="idProducto">
                        <mat-option [value]="item.id" *ngFor="let item of this.listasProductos">{{item.descripcion}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Expediente (*)</mat-label>
                    <input matInput formControlName="expediente" autocomplete="off" (keyup.enter)="ConsultarRegistros()">
                    <button (click)="ConsultarRegistros()" mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
    <div class="pl-0 pr-0 mat-elevation-z8">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- expediente Column -->
                <ng-container matColumnDef="expediente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Expediente </th>
                    <td mat-cell *matCellDef="let row"> {{row.expediente}} </td>
                </ng-container>
                <!-- fechaCreacion Column -->
                <ng-container matColumnDef="fechaCreacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha creación </th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaCreacion | fechapipe}} </td>
                </ng-container>
                <!-- descripcionEstado Column -->
                <ng-container matColumnDef="descripcionEstado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                    <td mat-cell *matCellDef="let row">
                        <span *ngIf="row.estado === 'PRO'" class="txtActivo">{{row.descripcionEstado}}</span>
                        <span *ngIf="row.estado === 'ANU'" class="txtInactivo">{{row.descripcionEstado}}</span>
                        <span *ngIf="row.estado === 'PEN'" class="txtBloqueado">{{row.descripcionEstado}}</span>
                    </td>
                </ng-container>
                <!-- afiliado Column -->
                <ng-container matColumnDef="afiliado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Afiliado </th>
                    <td mat-cell *matCellDef="let row"> {{row.nombreCompleto}} </td>
                </ng-container>
                <!-- cliente Column -->
                <ng-container matColumnDef="cliente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                    <td mat-cell *matCellDef="let row"> {{row.aliado}} </td>
                </ng-container>
                <!-- programa Column -->
                <ng-container matColumnDef="programa">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Programa </th>
                    <td mat-cell *matCellDef="let row"> {{row.descripcionProducto}} </td>
                </ng-container>
                <!-- gestiono Column -->
                <ng-container matColumnDef="gestiono">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Gestiono </th>
                    <td mat-cell *matCellDef="let row"> {{row.usuario}} </td>
                </ng-container>
                <!-- cierre Column -->
                <ng-container matColumnDef="cierre">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cierre </th>
                    <td mat-cell *matCellDef="let row"> {{row.cierre | fechapipe}} </td>
                </ng-container>

                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" class="icnTable" (click)="eliminarDetalle(row)" *ngIf="ItemEstadoPendiente(row)">
                            <mat-icon>cancel</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="procesarDetalle(row)" *ngIf="ItemEstadoPendiente(row)">
                            <mat-icon>check_circle</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="editarDetalle(row)" *ngIf="ItemEstadoPendiente(row)">
                            <mat-icon>edit</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
</div>